import { render, staticRenderFns } from "./CourseTotalLearningTimePanel.vue?vue&type=template&id=472a4a86"
import script from "./CourseTotalLearningTimePanel.vue?vue&type=script&lang=js"
export * from "./CourseTotalLearningTimePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports